import { render, staticRenderFns } from "./InfinityUpdater.vue?vue&type=template&id=6abb2d83"
import script from "./InfinityUpdater.vue?vue&type=script&lang=js"
export * from "./InfinityUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports